import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesAutomacoes {
  ler: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `automacoes`
 * (`apps/api/src/modules/automacoes/automacoes.routes.ts`): nenhum
 * papel além de `admin` (curinga `*`) foi seedado — ligar/desligar uma
 * regra que afeta todo o sistema é uma decisão administrativa, mesmo
 * critério de `/core/status` (`DECISIONS.md`, DEC-032).
 */
export function permissoesAutomacoes(papel: PapelUsuario): PermissoesAutomacoes {
  if (papel === 'admin') return { ler: true, atualizar: true };
  return { ler: false, atualizar: false };
}
